module.exports = __webpack_public_path__ + "static/media/MN.b2185c1f.svg";